import { useRouter } from 'next/router';

export const isWlPage = (query: Record<string, string | string[]>) =>
  query.wl === 'true' || query.pageType === 'mobile';

export const useIsWlPage = () => {
  const { query } = useRouter();

  return isWlPage(query);
};
